module.exports = __webpack_public_path__ + "img/mapa__canada.a201127b.png";